/*=========================================================================================
  File Name: state.js
  Namespace: taxonomy
  Description: Vuex Store - Taxonomy state
==========================================================================================*/

export const buildTaxonomyContentState = () => {
  return {
    contentId: null,
    addedSkills: [],
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  videoTaxonomy: buildTaxonomyContentState(),
  labTaxonomy: buildTaxonomyContentState(),
}

export default state